export const email = [
    v => /.+@.+/.test(v) || "E-mail must be valid",
    v => !!v || "Email is required",
];

export const password = [
    v => /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{8,})/.test(v) || "Password must be at least 8 characters and contain at least one letter and one number",
    v => !!v || "Password is required",
];

export default {
    email: email,
    password: password,
};